import { Modal } from 'react-bootstrap';
import './FontUpload.scss';
import FontUploadIcon from '../../images/font-upload.svg'
import FontSearchIcon from '../../images/library-searchIcon.svg'
import CloseIcon from "../../images/Close-Red-Icon.svg";
import AddFontIcon from "../../images/AddSlideNewIcon.svg";
import disabledState from "../../images/disabledState.svg";
import { postFontFiles, getFontlist, updateDeckInfo } from "../../services/apis";
import Dropzone from "react-dropzone";
import CircularProgressBar from "../../utils/CircularProgressBar";


import { useState, createRef, useEffect } from 'react';
import { showErrorToast, showSuccessToast } from '../toastComponent/ToastComponent';

const data = ['Nunito Sans', 'Arial', 'Phosphate', 'Plantagenet Cherokee', 'PT Serif', 'Hiragino Maru Gothic ProN'];
const FontUpload = ({ uploadFont, setUploadFont, deckId, setFontlistAdded, editor }) => {
    const [loading, setLoading] = useState(false);
    const [globalFonts, setGlobalFonts] = useState([]);
    const [deckFonts, setDeckFonts] = useState([]);
    const [fileType, setFileType] = useState();
    const [FontNamePlaceholder, setFontNamePlaceholder] = useState(true);
    const [FontFamilyPlaceholder, setFontFamilyPlaceholder] = useState(true);
    const [importFromRepo, setimportFromRepo] = useState([]);
    const [addedToRightRepo, setAddedToRightRepo] = useState([]);
    const dropzoneRef = createRef();
    const [deckFontSearch, setDeckFontSearch] = useState('');
    const [globalFontsSearch, setGlobalFontsSearch] = useState('');
    const [actionPerformed, setActionPerformed] = useState(true)
    const [importRemoved, setImportRemoved] = useState([]);
    const [removedList, setRemovedList] = useState([]);

    useEffect(() => {
        fontListRepo();
    }, [])

    const handleCustomPlaceholder = (type) => {
        if (type === "FontName") {
            document.querySelector("#fontName-search-field").focus();
        } else {
            document.querySelector("#fontFamily-search-field").focus();
        }
    };

    const handleFontSearchFields = (e, type) => {
        const query = e.target.value;
        setGlobalFontsSearch(query);
        if (type === "FontInput") {
            if (e.target.value.trim().length > 0) {
                setFontNamePlaceholder(false);
            } else {
                setFontNamePlaceholder(true);
            }
        }
    }

    const handleFontFamilySearchFields = (e, type) => {
        const query = e.target.value;
        setDeckFontSearch(query);
        if (type === "FontFamilyInput") {
            if (e.target.value.trim().length > 0) {
                setFontFamilyPlaceholder(false);
            } else {
                setFontFamilyPlaceholder(true);
            }
        }
    }

    const fontImport = (formData, fileTypes) => {
        if (fileTypes === "font/ttf" || fileTypes === "font/otf") {

            postFontFiles(formData, (response, err, errCode) => {
                if (err) {
                    let errMsg = "The same font already exists, please check";
                    if (err?.response?.data?.error?.includes('Invalid')) {
                        errMsg = "Upload failed. Please rename the file";
                    }
                    if (err.response.data.err.includes('letters')) {
                        errMsg = "Invalid fine name. Only alphanumeric, underscore, hyphen, period and space are allowed";
                    }
                    showErrorToast(errMsg);
                } else {
                    //parse and save
                    showSuccessToast('Font added successfully');
                    const data = response.data;
                    fontListRepo("choose");
                }
            });
        } else {
            showErrorToast(' Please select correct file format');
        }

    }

    const onFileSelection = (accepted, rejected) => {
        let filetypeString = '';
        if (Object.keys(rejected).length !== 0) {

            // setTab1Value(2);
        } else {
            const formData = new FormData();
            accepted.forEach((uploadFile) => {
                if (uploadFile.size > 5242880) {
                    console.log(
                        "Image upload failed, cannot upload image of size more than 500Kb.!"
                    );
                    return;
                }
                formData.append("file", uploadFile);
                filetypeString = uploadFile.type;
                setFileType(uploadFile.type);
                // console.log('type', uploadFile, uploadFile.type)
            });
            fontImport(formData, filetypeString);
        }
    }

    const fontListRepo = (action) => {
        setLoading(true);
        getFontlist(deckId, (response, err, errCode) => {
            if (err) {
                setLoading(false);
            } else {
                //parse and save
                const data = response.data.response;
                const uploadedIds = data.deckFonts.map((font) => font._id);
                const fontFamilyEdit = data.deckFonts.filter((font) => (!importFromRepo.includes(font._id)));
                setGlobalFonts(data.fonts)
                if (action === "choose") {
                    if (addedToRightRepo) {
                        // setDeckFonts(addedToRightRepo)
                    } else {
                        setDeckFonts(data.deckFonts)
                    }

                } else {
                    setDeckFonts(data.deckFonts)
                    setimportFromRepo([...uploadedIds]);
                }


                //setFontlistAdded([...fontFamilyadded]);
                // console.log('-----------', fontFamilyEdit)
                setLoading(false);
            }
        });
    }

    const addFontToEditor = (fontDetail) => {

        // console.log('..........', fontDetail);
        setDeckFonts([...deckFonts, fontDetail])
        setimportFromRepo([...importFromRepo, fontDetail._id]);
        setAddedToRightRepo([...addedToRightRepo, fontDetail])
        setActionPerformed(false)
        if (removedList.length > 0 && removedList.includes(fontDetail._id)) {
            const list = importRemoved.filter((font) => font._id !== fontDetail._id);
            setImportRemoved([...list])
        }
    }
    const removeFontFromEditor = (fontDetail) => {
        const fonts = deckFonts.filter((font) => font._id !== fontDetail._id);
        const fontsId = importFromRepo.filter((id) => id !== fontDetail._id);
        const removedImport = deckFonts.filter((font) => font._id === fontDetail._id);
        setAddedToRightRepo([...fonts])
        setDeckFonts([...fonts]);
        setimportFromRepo([...fontsId]);
        setActionPerformed(false)
        setImportRemoved(removedImport);
        setRemovedList([...removedList, fontDetail._id])
    }

    const uploadtoEditor = () => {
        const payload = { 'uploaded_fonts': importFromRepo };
        setLoading(true);
        updateDeckInfo(deckId, payload, (response, err, errorCode) => {
            if (err) {
                if (errorCode === 400) {
                    showErrorToast(err.response.data.message);
                }
                setLoading(false);
            } else {
                // console.log('after upload', response);
                const uploadedFonts = response.data.uploaded_fonts; let fontCss;
                const fontFromShared = response.data?.deck_shared_assets?.fonts || [];
                let cssString = editor.getCss();
                for (var i = 0; i < deckFonts.length; i++) {
                    fontCss = `@font-face{font-family:${deckFonts[i]?.name?.split('.')[0]};src:url("${deckFonts[i]?.link}");}`;

                    if (cssString.indexOf(fontCss) === -1) {
                        editor.Css.addRules(fontCss);
                        //  cssString += fontCss;
                    } else {
                        //  editor.Css.remove(fontCss)
                    }
                }

                if (importRemoved.length > 0) {
                    let finalCss;
                    importRemoved.forEach((list) => {

                        const removeCss = `@font-face{font-family:${list?.name?.split('.')[0]};src:url("${list?.link}");}`;
                        // console.log('remove css', removeCss)
                        finalCss = cssString.replaceAll(removeCss, ' ')
                    })
                    editor.CssComposer.clear();
                    editor.Css.addRules(finalCss);
                }
                const fontFamilyadded = deckFonts.map((font) => ({ value: font?.name?.split('.')[0], name: font?.name?.split('.')[0] }));
                const sharedFontFamilyadded = fontFromShared?.map((font) => ({ value: font?.name?.split('.')[0], name: font?.name?.split('.')[0] }));
                setimportFromRepo([...importFromRepo, ...uploadedFonts]);
                //setFontlistAdded([{ 'name': 'oswal1', 'value': 'oswal11' }])//([...fontFamilyadded])
                setLoading(false);
                setUploadFont(false)
                const fontlist = editor.StyleManager.getProperty("typography", "font-family");
                const defaultFamily = [
                    {value:'inherit',
                        name: 'Inherit'
                      },
                    {
                        value: "'Calibri', sans-serif",
                        name: "Calibri",
                    },
                   /*  { value: "'Oswald', sans-serif", name: "Oswald" }, */
                    // { value: "Helvetica Neue, Helvetica, Arial,sans-serif", name: "Helvetica" },
                    { value: "'Times New Roman', serif", name: "Times New Roman" },
                    { value: "Arial, sans-serif", name: "Arial" },
                    { value: "Tahoma, sans-serif", name: "Tahoma" },
                    {
                        value: "Verdana, Geneva, sans-serif",
                        name: "Verdana",
                    },
                    {
                        value: "'Courier New', monospace",
                        name: "Courier New",
                    },
                    { value: "'Lato', sans-serif", name: "Lato" },
                    {
                        value: "'Open Sans', sans-serif",
                        name: "Open Sans",
                    },
                    {
                        value: "'Montserrat', sans-serif",
                        name: "Montserrat",
                    }
                ];
                fontlist.set("options", [...defaultFamily, ...fontFamilyadded, ...sharedFontFamilyadded]);


            }
        })
    }
    return (
        <>
            {loading && (
                <CircularProgressBar
                    isloading={loading}
                    setIsloading={setLoading}
                />
            )}
            <div>
                <Modal
                    show={uploadFont}
                    // onHide={closeCreateTemplateModal}
                    className="font-upload"
                >
                    <Modal.Header className="">
                        <Modal.Title className='font-upload-title'>
                            ADD/REMOVE FONT FAMILY
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='font-upload-main d-flex'>
                            <div className='font-upload-left-content'>
                                <div className='font-upload-content'>
                                    <div className='font-content'>
                                        <h2 className='font-upload-left-header'>Choose/Upload Font</h2>
                                        <div className='d-flex'>
                                            <div className="d-flex font-search">
                                                <div className='font-search-icon'>
                                                    <img
                                                        alt="search"
                                                        src={FontSearchIcon}
                                                        className=""
                                                    ></img>
                                                    {FontNamePlaceholder && (<div
                                                        className="font-search-placeholder"
                                                        onClick={(e) => handleCustomPlaceholder('FontName')}
                                                    >
                                                        Search by &nbsp;
                                                        <span>
                                                            ‘Font Name’
                                                        </span>
                                                    </div>)}
                                                </div>
                                                <input
                                                    //   value={searchMetadata?.searchInput}
                                                    id="fontName-search-field"
                                                    type="text"
                                                    name="searchInput"
                                                    className="font-name-search-field"
                                                    onChange={(e) => handleFontSearchFields(e, "FontInput")}
                                                    autoComplete="off"
                                                    //   onKeyDown={handleOnEnter}
                                                    autoFocus
                                                //  onKeyPress={handleEnterKeypress}
                                                />
                                            </div>
                                            <div>
                                                <Dropzone
                                                    ref={dropzoneRef}
                                                    // multiple={true}
                                                    multiple={false}
                                                    accept=".ttf"
                                                    onDrop={(accepted, rejected) => onFileSelection(accepted, rejected)}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <div {...getRootProps()} className="presentation">
                                                            <input {...getInputProps()} />
                                                            <div className="chooseFileBlock">
                                                                <img src={FontUploadIcon} />

                                                                <a className="chooseFile" href="javascript:void(0)">
                                                                    Choose File
                                                                </a>

                                                            </div>
                                                        </div>
                                                    )}

                                                </Dropzone>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='font-upload-left-list'>
                                    <ul className='font-list'>
                                        {globalFonts && globalFonts?.filter(list => {
                                            return globalFontsSearch.toLowerCase() === '' ? list : list.name.toLowerCase().includes(globalFontsSearch.toLowerCase())
                                        }).map((list, id) => (
                                            <li key={id} className={`${importFromRepo.includes(list._id) ? 'disabledFont' : ''}`} onClick={() => addFontToEditor(list)}>{list.name.split('.')[0]} <img src={`${importFromRepo.includes(list._id) ? disabledState : AddFontIcon}`} width={16} height={16} alt="" /></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className='font-upload-right-content'>
                                <div className='added-font-family'>
                                    <h2 className='font-upload-right-header'>Added Font Family </h2>
                                    <div className="d-flex font-search">
                                        <div className='font-search-icon'>
                                            <img
                                                alt="search"
                                                src={FontSearchIcon}
                                                className=""
                                            ></img>
                                            {FontFamilyPlaceholder && (<div
                                                className="font-search-placeholder"
                                                onClick={(e) => handleCustomPlaceholder('fontFamily')}
                                            >
                                                Search by &nbsp;
                                                <span>
                                                    ‘Font Name’
                                                </span>
                                            </div>)}
                                        </div>
                                        <input
                                            //   value={searchMetadata?.searchInput}
                                            id="fontFamily-search-field"
                                            type="text"
                                            name="searchInput"
                                            className="font-family-search-field"
                                            onChange={(e) => handleFontFamilySearchFields(e, "FontFamilyInput")}
                                            autoComplete="off"
                                            //   onKeyDown={handleOnEnter}
                                            autoFocus
                                        //  onKeyPress={handleEnterKeypress}
                                        />
                                    </div>
                                </div>
                                <div className='font-upload-right-list'>
                                    <ul className='font-list'>
                                        {deckFonts && deckFonts?.filter(list => {
                                            return deckFontSearch.toLowerCase() === '' ? list : list.name.toLowerCase().includes(deckFontSearch.toLowerCase())
                                        }).map((list, id) => (
                                            <li key={id} onClick={() => removeFontFromEditor(list)} >{list?.name?.split('.')[0]} <img src={CloseIcon} width={18} height={18} alt="" /></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex'>
                            <button className='font-cancel-btn' onClick={() => setUploadFont(false)}>CANCEL</button>
                            <button className='font-upload-btn' disabled={actionPerformed} onClick={uploadtoEditor}>CONFIRM</button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
}

export default FontUpload;